var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { mediaQuery, colCount, spanWidth, pushWidth, margin, } from '../../utils/grid';
const ColumnStyle = styled((_a) => {
    var { className, children, id } = _a, rest = __rest(_a, ["className", "children", "id"]);
    const dataProps = {};
    Object.keys(rest)
        .filter((key) => key.startsWith('data-') || key.startsWith('aria-'))
        .forEach((key) => {
        dataProps[key] = rest[key];
    });
    return (React.createElement("div", Object.assign({ className: className, id: id }, dataProps), children));
}) `
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-self: ${({ alignSelf }) => alignSelf};
  justify-content: space-between;

  ${({ wrap }) => wrap &&
    css `
      flex-wrap: wrap;
    `}
  ${({ order }) => order && typeof order !== 'number'
    ? Object.keys(order).map((layoutId) => css `
            @media ${mediaQuery(layoutId)} {
              order: ${order[layoutId]};
            }
          `)
    : css `
          order: ${order};
        `}
  ${({ debug, span, parentSpan, push = 0, theme, }) => Object.keys(theme.layouts).map((layoutId) => {
    const spanCount = colCount(span, layoutId);
    const pushCount = colCount(push, layoutId);
    if (spanCount < 1 || pushCount < 0) {
        return null;
    }
    return css `
        @media ${mediaQuery(layoutId)} {
          ${debug &&
        css `
            &::before {
              content: 'span ${spanCount}';
            }
          `}
          ${pushCount > 0 &&
        margin(layoutId)({ theme }) > 0 &&
        css `
            margin-left: ${pushWidth({ layoutId, push, parentSpan })};
          `}
          max-width: ${spanWidth({ layoutId, span, parentSpan })};
        }
      `;
})};
  ${({ debug, debugColor }) => debug &&
    css `
      position: relative;
      border: 1px solid;
      border-color: ${debugColor};

      &::before {
        background: white;
        position: absolute;
        top: -12px;
        left: 4px;
        padding: 2px 4px;
        border: 1px solid ${debugColor};
        font: 12px sans-serif;
      }
    `}
`;
ColumnStyle.defaultProps = {
    order: 0,
};
export default ColumnStyle;
//# sourceMappingURL=ColumnStyle.js.map